import React, { FC, ReactNode, memo } from 'react';
import Text, { TextColors } from '../Text';
import './style.scss';

interface Props {
  color?: TextColors;
  children: ReactNode;
  className?: string;
}

const ServiceTitle: FC<Props> = ({ children, color = 'dark', className }) => {
  return (
    <Text
      type="h2"
      weight="medium"
      className={`service__title ${className}`}
      color={color}
    >
      {children}
    </Text>
  );
};

export default memo(ServiceTitle);
